import { AfterViewInit, Component, NgZone, OnInit } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AppRootService, MicroserviceService, TranslateService, RegionalSettingsService } from 'cs-shared-lib';
import { ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-service-bridge',
  imports: [],
  templateUrl: './service-bridge.html',
})
export class ServiceBridge implements AfterViewInit {

  isReady: boolean = false;

  subscription: Subscription = new Subscription();

  constructor(
    private ngZone: NgZone,
    private _router: Router,
    @Inject(DOCUMENT) protected document: Document,
    public appRootService: AppRootService,
    private microserviceService: MicroserviceService,
    // private activated: ActivatedRoute,
    private translateService: TranslateService,
    private regionalSettingsService: RegionalSettingsService,
    private elementRef: ElementRef,
    private fb: FormBuilder,
  ) {


    this.subscription.add(
      fromEvent(window, 'cs-v20-service-bridge' + ':init')
        .subscribe((res: any) => {
          if (res) {
            const { currentUrl, data } = res.detail;
            const {
              microserviceHelperService,
              translateService,
              csIntlSettings,
              csCountryCode,
              regionalDateFormats,
              csLanguage,
              csCurrencyCode,
              permissionFeatures,
              modulePermissions,
              allPermissions,
              countriesJSONData,
              ordinals
            } = data;
            this.appRootService.microserviceHelper = microserviceHelperService;
            this.translateService.service = translateService;
            this.regionalSettingsService.csIntlSettings = csIntlSettings;
            this.regionalSettingsService.regionalDateFormats = regionalDateFormats;
            this.regionalSettingsService.csCountryCode = csCountryCode;
            this.regionalSettingsService.csLanguage = csLanguage;
            this.regionalSettingsService.csCurrencyCode = csCurrencyCode;
            this.regionalSettingsService.countriesJSONData = countriesJSONData;
            this.regionalSettingsService.ordinals = ordinals;
            this.appRootService.modulePermissions = modulePermissions?.moduleDetails || {}
            this.appRootService.permissionFeatures = permissionFeatures || {};
            this.appRootService.accessDetails = allPermissions?.accessDetails || {};
            this.ngZone.run(() => {
              // this._router.navigateByUrl(currentUrl)
              //   .then(() => {
              //   });
            });
          }
        })
    );
  }

  ngAfterViewInit(): void {

    // Traverse up to find the custom element host
    let currentElement = this.elementRef.nativeElement;
    let customElementHost = null;

    // while (currentElement) {
    if (currentElement.tagName && currentElement.tagName.toLowerCase() === 'cs-v20-service-bridge') {
      customElementHost = currentElement;
      // break;
    }
    // Dispatch directly from Custom Element Host if found
    if (customElementHost) {
      customElementHost.dispatchEvent(new CustomEvent('onReady', { detail: this, bubbles: true, composed: true }));
      this.subscription.add(
        fromEvent(window, 'cs-v20-service-bridge' + ':init')
          .subscribe((res: any) => {
            if (res) {
              const { currentUrl, data } = res.detail;
              const {
                microserviceHelperService,
                translateService,
                csIntlSettings,
                csCountryCode,
                regionalDateFormats,
                csLanguage,
                csCurrencyCode,
                permissionFeatures,
                modulePermissions,
                allPermissions,
                ordinals
              } = data;
              this.appRootService.microserviceHelper = microserviceHelperService;
              this.translateService.service = translateService;
              this.regionalSettingsService.csIntlSettings = csIntlSettings;
              this.regionalSettingsService.regionalDateFormats = regionalDateFormats;
              this.regionalSettingsService.csCountryCode = csCountryCode;
              this.regionalSettingsService.csLanguage = csLanguage;
              this.regionalSettingsService.csCurrencyCode = csCurrencyCode;
              this.regionalSettingsService.ordinals = ordinals;
              this.appRootService.modulePermissions = modulePermissions?.moduleDetails || {}
              this.appRootService.permissionFeatures = permissionFeatures || {};
              this.appRootService.accessDetails = allPermissions?.accessDetails || {};
              this.ngZone.run(() => {
                // this._router.navigateByUrl(currentUrl)
                //   .then(() => {
                //   });
              });
            }
          })



      );
      // customElementHost.dispatchEvent(new CustomEvent('onready', { detail: this, bubbles: true, composed: true }));
    } else {

    }
  }

}
